module.exports = __webpack_public_path__ + "img/master.2a2b54e.png";